import React, { useEffect, useRef, useState } from "react";
import { FiX } from "react-icons/fi";

// Confirms a move near where the user is looking, and offers to take it back.
// Clears itself after six seconds, but not while hovered or focused.
export function MoveToast({ notice, language, busy, onUndo, onOpen, onDismiss }) {
  const zh = language === "zh";
  const [paused, setPaused] = useState(false);
  const dismiss = useRef(onDismiss);
  dismiss.current = onDismiss;

  useEffect(() => {
    if (!notice || paused) return;
    const timer = setTimeout(() => dismiss.current(), 6000);
    return () => clearTimeout(timer);
  }, [notice, paused]);

  if (!notice) return null;

  const name = notice.folder || (zh ? "未分類" : "Unfiled");
  const message = notice.undone
    ? zh ? `已移回「${name}」。` : `Moved back to ${name}.`
    : zh ? `已移至「${name}」。` : `Moved to ${name}.`;
  const action =
    "shrink-0 px-2 py-1 rounded-md font-semibold text-orange-300 dark:text-orange-700 hover:bg-white/10 dark:hover:bg-black/5 disabled:opacity-50";

  return (
    <div className="fixed inset-x-0 bottom-6 z-50 flex justify-center px-4 pointer-events-none">
      <div
        role="status"
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        onFocus={() => setPaused(true)}
        onBlur={() => setPaused(false)}
        className="pointer-events-auto flex items-center gap-1 max-w-full pl-4 pr-1.5 py-1.5 rounded-xl bg-gray-900 text-white dark:bg-gray-100 dark:text-gray-900 shadow-lg text-sm animate-slideUp"
      >
        <span className="mr-2 min-w-0 break-words">{message}</span>
        {!notice.undone && (
          <button type="button" disabled={busy} onClick={onUndo} className={action}>
            {zh ? "復原" : "Undo"}
          </button>
        )}
        <button type="button" onClick={onOpen} className={action}>
          {notice.folder ? (zh ? "開啟資料夾" : "Open folder") : zh ? "查看未分類" : "Open Unfiled"}
        </button>
        <button
          type="button"
          aria-label={zh ? "關閉" : "Dismiss"}
          onClick={onDismiss}
          className="shrink-0 w-7 h-7 inline-flex items-center justify-center rounded-md text-gray-400 dark:text-gray-500 hover:bg-white/10 dark:hover:bg-black/5"
        >
          <FiX aria-hidden="true" className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
